/**
 * `/app/widgets/$widgetRef/forms/$formKey` — one form, in its editor. The page is
 * `pages/forms/FormEditorPage.tsx`; a key the widget has no form for is the API's 404,
 * rendered inside the portal by the route boundary.
 */

import { createFileRoute } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { FormEditorPage } from '../../../../../pages/forms/FormEditorPage.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/forms/$formKey')({
  notFoundComponent: NotFound,
  component: FormRoute,
})

function FormRoute() {
  const { widgetRef, formKey } = Route.useParams()
  return <FormEditorPage widgetRef={widgetRef} formKey={formKey} />
}
